import {useNavigate} from "react-router-dom";
import PageHeader from "../../layout/PageHeader";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <>
      <PageHeader valid={true}/>
      <section className="container py-5">
        <h1>Brak dostępu</h1>
        <p>Nie masz uprawnień do wyświetlenia tej strony.</p>
        <button className="btn btn-secondary" onClick={() => navigate(-1)}>Wstecz</button>
      </section>
    </>
  );
};

export default Unauthorized;
